import React, { useState } from "react";
import { FiDownload, FiUpload, FiHelpCircle, FiAward, FiBell, FiX, FiActivity } from "react-icons/fi";
import "./Home.css";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next"; // i18n hook add kiya

// IMPORT LIVE WITHDRAWAL COMPONENT
import LiveWithdrawal from "./LiveWithdrawal";

/* Quick action button */
const QA = ({ icon: Icon, label, onClick, className = "" }) => (
  <button className={`home-qa ${className}`} onClick={onClick} type="button">
    <div className="qa-icon-circle">
      <Icon className="qa-ico" />
    </div>
    <span>{label}</span>
  </button>
);

export default function HomePage() {
  const { t } = useTranslation(); // Translation initialization
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);
  const [showRules, setShowRules] = useState(false);
  const [showCoop, setShowCoop] = useState(false);
  const [showFaq, setShowFaq] = useState(false);
  const [showCert, setShowCert] = useState(false);
  const [showGuide, setShowGuide] = useState(false);

  /* Locked images */
  const IMG = {
    profile: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=85&v=1",
    rules: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=85&v=1",
    coop: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=85&v=1",
    guide: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=85&v=1",
    cert: "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?auto=format&fit=crop&w=1200&q=85&v=1",
  };

  const cards = [
    {
      id: 1,
      img: IMG.profile,
      title: t("Platform profile"),
      text: t("MALL is an intelligent cloud order matching center that helps users earn stable commissions through global e-commerce optimization."),
      onClick: () => setShowProfile(true),
    },
    {
      id: 2,
      img: IMG.rules,
      title: t("Platform rules"),
      text: t("Comprehensive recharge and withdrawal guidelines. Learn about our transparent settlement system and auditing procedures."),
      onClick: () => setShowRules(true),
    },
    {
      id: 3,
      img: IMG.coop,
      title: t("Win win cooperation"),
      text: t("Strategic partnerships with tiered VIP benefits. Explore how long-term collaboration maximizes your revenue potential."),
      onClick: () => setShowCoop(true),
    },
    {
      id: 4,
      img: IMG.guide,
      title: t("Instructions for use"),
      text: t("A complete step-by-step walkthrough for new users to start their journey, manage assets, and execute tasks efficiently."),
      onClick: () => setShowGuide(true),
    },
  ];

return (
    <div className="wrap home-page">
      {/* TOP BAR */}
      <header className="home-top">
        <div className="logo-section">
          {/* یہاں ت (t) فنکشن کے ساتھ کی (key) اپ ڈیٹ کر دی ہے */}
          <span className="home-title">{t("noon_mart")}</span>
        </div>
        <button className="bell" aria-label="Notifications" type="button">
          <FiBell />
        </button>
      </header>

      {/* QUICK ACTIONS */}
      <nav className="home-qa-grid">
        <QA 
          icon={FiDownload} 
          label={t("Recharge")} 
          className="recharge" 
          onClick={() => navigate('/deposit', { state: { from: 'home' } })} 
        />
        <QA 
          icon={FiUpload} 
          label={t("Withdrawal")} 
          className="withdrawal" 
          onClick={() => navigate('/withdraw')} 
        />
        <QA icon={FiHelpCircle} label={t("FAQ")} className="faq-btn" onClick={() => setShowFaq(true)} />
        <QA icon={FiAward} label={t("Certificate")} className="cert-btn" onClick={() => setShowCert(true)} />
      </nav>

      {/* LIVE WITHDRAWAL SECTION */}
      <div style={{ marginTop: "10px" }}>
        <LiveWithdrawal />
      </div>

      {/* IMAGE GRID CARDS */}
      <div className="home-cards-wrap" style={{ marginTop: "10px" }}>
        <div className="home-cards">
          {cards.map((it) => (
            <article key={it.id} className="home-card" role="button" tabIndex={0} onClick={it.onClick}>
              <div
                className="hc-photo"
                style={{ backgroundImage: `url(${it.img})` }}
                aria-label={it.title}
              />
              <div className="hc-body">
                <h4 className="hc-title">{it.title}</h4>
                <p className="hc-text">{it.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* ===== INSTRUCTIONS FOR USE OVERLAY ===== */}
      {showGuide && (
        <div className="sheet-overlay" onClick={() => setShowGuide(false)}>
          <div className="profile-sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <header className="ps-head">
              <h2 className="ps-title">{t("Instructions for use")}</h2>
              <button className="ps-close" type="button" onClick={() => setShowGuide(false)}>
                <FiX />
              </button>
            </header>
            <div className="ps-body">
              <h4>{t("Operating Procedures")}</h4>
              <p>{t("Follow these professional guidelines to ensure optimal account performance and commission generation:")}</p>
              <ol>
                <li><strong>{t("Account Funding:")}</strong> {t("Complete a minimum deposit of 10 USDT to activate your cloud matching capabilities.")}</li>
                <li><strong>{t("Task Execution:")}</strong> {t("Navigate to the \"Grabbing\" center and initiate the automated matching process.")}</li>
                <li><strong>{t("Order Submission:")}</strong> {t("Verify product details and submit matched orders within the 10-minute validity window.")}</li>
                <li><strong>{t("Settlement:")}</strong> {t("Commissions are automatically calculated and disbursed to your account balance upon successful order synchronization.")}</li>
              </ol>

              <h4 style={{marginTop: '15px'}}>{t("Combo Task Protocol")}</h4>
              <p>{t("To enhance merchant ranking efficiency, the system intermittently triggers Combo Tasks during your daily operation sequence:")}</p>
              <ul>
                <li><strong>{t("Frequency:")}</strong> {t("In a standard 25-task cycle, approximately 1-3 high-yield Combo Tasks may be randomly assigned.")}</li>
                <li><strong>{t("Incentive:")}</strong> {t("These tasks offer significantly higher commission rates compared to standard matching orders.")}</li>
                <li><strong>{t("Execution Requirement:")}</strong> {t("Due to the high value of products in these tasks, a temporary supplementary deposit may be required if your current account balance is below the order threshold.")}</li>
                <li><strong>{t("Completion:")}</strong> {t("Once the Combo Task sequence is finalized, both the principal and the accumulated high-value commissions are immediately released for withdrawal.")}</li>
              </ul>
              <p style={{fontSize: '0.85rem', color: '#666', borderTop: '1px solid #eee', paddingTop: '10px'}}>{t("Note: Combo tasks are essential for system-wide liquidity and cannot be bypassed once initiated.")}</p>
            </div>
            <footer className="ps-foot">
              <span className="ps-note">{t("Tap outside to close")}</span>
            </footer>
          </div>
        </div>
      )}

      {/* ===== PROFILE OVERLAY ===== */}
      {showProfile && (
        <div className="sheet-overlay" onClick={() => setShowProfile(false)}>
          <div className="profile-sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <header className="ps-head">
              <h2 className="ps-title">{t("Platform profile")}</h2>
              <button className="ps-close" type="button" onClick={() => setShowProfile(false)}>
                <FiX />
              </button>
            </header>
            <p className="ps-kicker">{t("Intelligent cloud order matching for global e commerce.")}</p>
            <div className="ps-body">
              <p>
                {t("MALL is a premier intelligent cloud-based order matching center. We utilize high-speed API integrations to support the world's leading retail platforms including Amazon, Alibaba, AliExpress, Souq, Jumia, MaxFashion, and Daraz.")}
              </p>
              <p>
                {t("Our mission is to bridge the gap between global merchants and consumers. Through advanced online traffic optimization and dynamic product data reconstruction, MALL enhances merchant visibility while providing users a stable environment to earn daily commissions. Our AI-driven cloud algorithm ensures that every order is matched with 100% accuracy and security.")}
              </p>
              <p>
                {t("By participating in the MALL ecosystem, consumers contribute to a vast network of promoters that drives global order fulfillment, receiving a fair share of the profits generated by these international trade transactions.")}
              </p>
              <p>
                {t("Powered by state-of-the-art 5G cloud matching technology, MALL is committed to delivering innovation, operational efficiency, and sustainable mutual growth for all stakeholders in the digital economy.")}
              </p>
            </div>
            <footer className="ps-foot">
              <span className="ps-note">{t("Tap outside to close")}</span>
            </footer>
          </div>
        </div>
      )}

      {/* ===== RULES OVERLAY ===== */}
      {showRules && (
        <div className="sheet-overlay" onClick={() => setShowRules(false)}>
          <div className="profile-sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <header className="ps-head">
              <h2 className="ps-title">{t("Platform rules and guidelines")}</h2>
              <button className="ps-close" type="button" onClick={() => setShowRules(false)}>
                <FiX />
              </button>
            </header>
            <div className="ps-body">
              <h4>{t("1. Recharge instructions")}</h4>
              <ul>
                <li>{t("To ensure account safety, recharge methods are updated periodically. Always check the current Recharge screen for the latest payment address.")}</li>
                <li>{t("In case of transaction delays due to network congestion, please keep your transaction hash (TXID) ready and contact the recharge support team immediately.")}</li>
                <li>{t("Ensure you are using the correct network (e.g., TRC20) to avoid loss of funds.")}</li>
              </ul>

              <h4>{t("2. Withdrawal policy")}</h4>
              <ul>
                <li>{t("Minimum withdrawal: 20 USDT. Minimum deposit: 10 USDT.")}</li>
                <li>{t("Withdrawal requests are audited by our smart contract system. Most payments are credited within 24 hours.")}</li>
                <li>{t("During periods of high platform traffic or manual security audits, delays may occur. Your patience is appreciated.")}</li>
                <li>{t("If your funds have not arrived after 24 hours of successful audit, please contact our 24/7 dedicated customer service.")}</li>
              </ul>

              <h4>{t("3. Order freezing and Safety")}</h4>
              <ul>
                <li>{t("System safety protocols freeze orders if a task is not submitted within 10 minutes of matching to prevent data inconsistency.")}</li>
                <li>{t("If an order is stuck, navigate to Home → Order and re-submit the pending task to release your balance.")}</li>
              </ul>

              <h4>{t("4. Account registration and security")}</h4>
              <ul>
                <li>{t("MALL strictly enforces a \"One Person, One Account\" policy. Each user must register with a unique, valid mobile number.")}</li>
                <li>{t("The use of multiple accounts, VPNs, or proxy IPs to manipulate tasks is strictly prohibited. Violators will face account freezing and permanent forfeiture of withdrawal rights.")}</li>
              </ul>

              <h4>{t("5. VIP levels and trading rules")}</h4>
              <table className="vip-table">
                <thead>
                  <tr>
                    <th>{t("VIP level")}</th>
                    <th>{t("Platform")}</th>
                    <th>{t("Balance (USDT)")}</th>
                    <th>{t("Comm.")}</th>
                    <th>{t("Status")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>{t("VIP 1")}</td><td>{t("Amazon")}</td><td>20 – 498</td><td>4%</td><td><span className="badge ok">{t("Active")}</span></td></tr>
                  <tr><td>{t("VIP 2")}</td><td>{t("Alibaba")}</td><td>499 – 899</td><td>8%</td><td><span className="badge ok">{t("Active")}</span></td></tr>
                  <tr><td>{t("VIP 3")}</td><td>{t("AliExpress")}</td><td>899+</td><td>12%</td><td><span className="badge ok">{t("Active")}</span></td></tr>
                  <tr><td>{t("VIP 4")}</td><td>{t("eBay")}</td><td>2000+</td><td>18%</td><td><span className="badge lock">{t("Locked")}</span></td></tr>
                </tbody>
              </table>
            </div>
            <footer className="ps-foot">
              <span className="ps-note">{t("Tap outside to close")}</span>
            </footer>
          </div>
        </div>
      )}

      {/* ===== COOP OVERLAY ===== */}
      {showCoop && (
        <div className="sheet-overlay" onClick={() => setShowCoop(false)}>
          <div className="profile-sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <header className="ps-head">
              <h2 className="ps-title">{t("Win win cooperation")}</h2>
              <button className="ps-close" type="button" onClick={() => setShowCoop(false)}>
                <FiX />
              </button>
            </header>
            <div className="ps-body">
              <p>
                {t("MALL thrives on a collaborative model. We believe that long-term partnerships are the cornerstone of a sustainable digital marketplace. Our \"Win-Win\" strategy combines smart algorithmic matching with a robust reward structure.")}
              </p>
              <h4>{t("Operational Workflow")}</h4>
              <ol>
                <li><strong>{t("Task Discovery:")}</strong> {t("Our system analyzes your VIP tier and balance to provide optimized matching tasks.")}</li>
                <li><strong>{t("Cloud Verification:")}</strong> {t("Once a task is completed, our cloud-based engine verifies the transaction in real-time to ensure legitimacy.")}</li>
                <li><strong>{t("Instant Settlement:")}</strong> {t("Earned commissions are credited to your account instantly upon verification, allowing for rapid reinvestment or withdrawal.")}</li>
              </ol>
              <h4>{t("The Ecosystem Partners")}</h4>
              <ul>
                <li><strong>{t("Consumers:")}</strong> {t("Act as digital promoters, increasing product popularity and earning lucrative commissions.")}</li>
                <li><strong>{t("Merchants:")}</strong> {t("Gain access to high-quality, targeted traffic that boosts their global sales ranking and fulfillment rates.")}</li>
                <li><strong>{t("The MALL Platform:")}</strong> {t("Acts as a secure intermediary, providing the necessary technological infrastructure, risk management, and liquidity.")}</li>
              </ul>
            </div>
            <footer className="ps-foot">
              <span className="ps-note">{t("Tap outside to close")}</span>
            </footer>
          </div>
        </div>
      )}

      {/* ===== FAQ OVERLAY ===== */}
      {showFaq && (
        <div className="sheet-overlay" onClick={() => setShowFaq(false)}>
          <div className="profile-sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <header className="ps-head">
              <h2 className="ps-title">{t("Frequently Asked Questions")}</h2>
              <button className="ps-close" type="button" onClick={() => setShowFaq(false)}>
                <FiX />
              </button>
            </header>
            <div className="ps-body">
              <div className="faq-item">
                <h5>{t("What is MALL?")}</h5>
                <p>{t("MALL is a global order-matching platform designed to increase the sales volume and rankings of international e-commerce merchants through a distributed user network.")}</p>
              </div>
              <div className="faq-item">
                <h5>{t("Is my capital safe?")}</h5>
                <p>{t("Yes. All transactions are backed by merchant security deposits. Your principal and commissions are protected by our cloud-based risk management protocol.")}</p>
              </div>
              <div className="faq-item">
                <h5>{t("How do I upgrade my VIP level?")}</h5>
                <p>{t("VIP levels are determined by your account balance and total task completion volume. Higher VIP levels unlock access to more premium platforms and higher commission percentages.")}</p>
              </div>
              <div className="faq-item">
                <h5>{t("Why was my withdrawal rejected?")}</h5>
                <p>{t("Common reasons include incomplete tasks, bank information errors, or violation of our multi-account policy. Please check your account status or contact support.")}</p>
              </div>
              <div className="faq-item">
                <h5>{t("Can I change my withdrawal address?")}</h5>
                <p>{t("For security reasons, once a withdrawal address is bound, it can only be changed by contacting our senior security administrators through verified identity checks.")}</p>
              </div>
            </div>
            <footer className="ps-foot">
              <span className="ps-note">{t("Tap outside to close")}</span>
            </footer>
          </div>
        </div>
      )}

      {/* ===== CERTIFICATE OVERLAY ===== */}
      {showCert && (
        <div className="sheet-overlay" onClick={() => setShowCert(false)}>
          <div className="profile-sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <header className="ps-head">
              <h2 className="ps-title">{t("Professional Certification")}</h2>
              <button className="ps-close" type="button" onClick={() => setShowCert(false)}>
                <FiX />
              </button>
            </header>
            <div className="ps-body cert-view">
              <div className="cert-img-container">
                <img src={IMG.cert} alt="Official Platform Certificate" className="full-cert-img" />
              </div>
              <div className="cert-details">
                <h4>{t("Legal Authorization")}</h4>
                <p>{t("MALL is a fully registered and licensed entity specializing in digital marketing and e-commerce consulting. Our operations comply with international trade regulations and digital asset management laws.")}</p>
                <p>{t("This certificate verifies that MALL is authorized to provide order-matching services for partner platforms including Amazon and Alibaba.")}</p>
                <ul>
                  <li><strong>{t("Registry No:")}</strong> {t("ML-889-INTL")}</li>
                  <li><strong>{t("License Category:")}</strong> {t("Cloud Computing & E-commerce Services")}</li>
                  <li><strong>{t("Compliance Status:")}</strong> {t("Fully Certified")}</li>
                </ul>
              </div>
            </div>
            <footer className="ps-foot">
              <span className="ps-note">{t("Tap outside to close")}</span>
            </footer>
          </div>
        </div>
      )}
    </div>
  );
}